var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0098 21.3711C12.1816 21.3711 12.9238 20.5312 12.9238 19.3203V12.9141H18.9785C20.1699 12.9141 21.0098 12.1914 21.0098 11.0195C21.0098 9.84766 20.1699 9.10547 18.9785 9.10547H12.9238V2.67969C12.9238 1.46875 12.1816 0.628906 11.0098 0.628906C9.81836 0.628906 9.07617 1.46875 9.07617 2.67969V9.10547H3.00195C1.81055 9.10547 0.990234 9.84766 0.990234 11.0195C0.990234 12.1914 1.81055 12.9141 3.00195 12.9141H9.07617V19.3203C9.07617 20.5312 9.81836 21.3711 11.0098 21.3711Z",
    fill: "#8082C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.7a3211821781bc5cbcd9c27c9ae318be.svg";
export { ForwardRef as ReactComponent };